
export const multip = (a: any, b: any) => {
  return a * b;
};
export const cityidfromcod = (code: any) => {
  let ctid =0;
  let arrcits = citycodeids;
	
	for(let i =0;i< arrcits.length;i++){
              
                 const rv = arrcits[i];
	         const cv = rv["label"];
 		 if(cv == code){	
		 ctid = rv["value"]; 
		 break;
		} 
		
	}
  return ctid;	
};
export const getcolmvalbykypr = (arrs:any,k: any,v: any,sk: any) => {
  let searchv = '';
 
	
	for(let i =0;i< arrs.length;i++){
              
                 const rv = arrs[i];
	         const cv = rv[k];
 		 if(cv == v){	
		 searchv = rv[sk]; 
		 break;
		} 
		
	}
  return searchv;	
};
export const getcolval = (arrs:any,k: any,v: any) => {
  let searchv = [{}];
 
	
	for(let i =0;i< arrs.length;i++){
              
                 const rv = arrs[i];
	         const cv = rv[k];
 		 if(cv == v){	
		 searchv.push(rv); 
		 
		} 
		
	}
  return searchv;	
};
export const getcolnotval = (arrs:any,k: any,v: any) => {
  let searchv = [{}];
 
	
	for(let i =0;i< arrs.length;i++){
              
                 const rv = arrs[i];
	         const cv = rv[k];
 		 if(cv != v){	
		 searchv.push(rv); 
		 
		} 
		
	}
  return searchv;	
};
 
 
export const  arutyps = [
	
	{ value: 8, label: 'Member' },
	{ value: 7, label: 'General' },
	{ value: 6, label: 'Company' }
	

];
export const  arutypsa = [
	{ value: 2, label: 'Admin' },
	{ value: 8, label: 'Member' },
	{ value: 7, label: 'General' },
	{ value: 6, label: 'Company' }
	

];
export const  arutypso = [
	{ value: 4, label: 'Official' },
	{ value: 8, label: 'Member' },
	{ value: 7, label: 'General' },
	{ value: 6, label: 'Company' }
	

];

export const  aroffers = [
	{ id: "0", oname: 'No offers available',val:0,units:'' },
	{ id: "1", oname: ' exclusive offer of 10 days free post',val:10,units:'day' },
       
];
export const  getprofileoffer = (oid: any)=>{
	const offrs = aroffers;
        let ofr ="";
	for(let i = 0;i<offrs.length;i++){
	  const ofobj = offrs[i];
          const oval = ofobj["id"];
	  if(oid == oval){
	    ofr = ofobj["oname"];
	     break;
	  }
	}
       return ofr;
};

export const  arrcomptype = [
	{ value: 1, label: 'Proprietorship' },
        
	{ value: 2, label: 'Partnership' },
	{ value: 3, label: 'OPC' },
	{ value: 4, label: 'LLP' },
	{ value: 5, label: 'PVT. Limited' },
	{ value: 6, label: 'Public Limited' },
	{ value: 7, label: 'Non profit Organization' },



];

export const arradvtype = [
{value:1,label:'Mainfullbackground'},
{value:2,label:'Mainhalfbackground'},
{value:3,label:'homefullbackground'},
{value:4,label:'Homehalfbackground'},
{value:5,label:'Searchtop'},
{value:6,label:'Searchmultiple'},
{value:7,label:'Searchcity'},
{value:8,label:'Searchcondition'},
{value:9,label:'Other'},


];

export const citiescodes = [

{ value:'DEH',label:'Dehli'},
{ value:'GUR',label:'Gurgaon'},
{ value:'NAV',label:'Navi mumbai'},
{ value:'MUM',label:'Mumbai'},
{ value:'KOL',label:'Kolkata'},
{ value:'HOW',label:'Howrah'},
{ value:'CHE',label:'Chennai'},
{ value:'HYD',label:'Hyderabad'},
{ value:'BEN',label:'Bengaluru'},
{ value:'AHM',label:'Ahmedabad'},
{ value:'SUR',label:'Surat'},
{ value:'AMR',label:'Amritsar'},
{ value:'BHO',label:'Bhopal'},
{ value:'BHU',label:'Bhubaneswar'},
{ value:'CUT',label:'Cuttack'},
{ value:'CHA',label:'Chandigarh'},
{ value:'FAR',label:'Farvalueabad'},
{ value:'GHA',label:'Ghaziabad'},
{ value:'JAM',label:'Jamshedpur'},
{ value:'JAI',label:'Jaipur'},
{ value:'KOC',label:'Kochi'},
{ value:'LUC',label:'Lucknow'},
{ value:'NAG',label:'Nagpur'},
{ value:'PAT',label:'Patna'},
{ value:'RAI',label:'Raipur'},
{ value:'VIS',label:'Visakhapatnam'},
{ value:'AGR',label:'Agra'},
{ value:'AJM',label:'Ajmer'},
{ value:'KAN',label:'Kanpur'},
{ value:'MYS',label:'Mysore'},
{ value:'SRI',label:'Srinagar'},
{ value:'PUN',label:'Pune'}

];
export const citycodeids = [

{ label:'DEH',value:1},
{ label:'GUR',value:2},
{ label:'NAV',value:3},
{ label:'MUM',value:4},
{ label:'KOL',value:5},
{ label:'HOW',value:6},
{ label:'CHE',value:7},
{ label:'HYD',value:8},
{ label:'BEN',value:9},
{ label:'AHM',value:10},
{ label:'SUR',value:11},
{ label:'AMR',value:12},
{ label:'BHO',value:13},
{ label:'BHU',value:14},
{ label:'CUT',value:15},
{ label:'CHA',value:16},
{ label:'FAR',value:17},
{ label:'GHA',value:18},
{ label:'JAM',value:19},
{ label:'JAI',value:20},
{ label:'KOC',value:21},
{ label:'LUC',value:22},
{ label:'NAG',value:23},
{ label:'PAT',value:24},
{ label:'RAI',value:25},
{ label:'VIS',value:26},
{ label:'AGR',value:27},
{ label:'AJM',value:28},
{ label:'KAN',value:29},
{ label:'MYS',value:30},
{ label:'SRI',value:31},
{ label:'PUN',value:32}

];

export const incities = [
        { value: 0, label: 'Others' },
        { value: 1, label: 'New Dehli' },
        { value: 2, label: 'Gurgaon' },
	 { value: 7, label: 'Chennai' },
        { value: 8, label: 'Hyderabad' },
        { value: 9, label: 'Bengaluru' },
        { value: 3, label: 'Navi Mumbai' },
        { value: 4, label: 'Mumbai' },

        { value: 5, label: 'Kolkata' },
        { value: 6, label: 'Howrah' },
       
        { value: 10, label: 'Ahmedabad' },
        { value: 11, label: 'Surat' },
        { value: 12, label: 'Amritsar' },
        { value: 13, label: 'Bhopal' },
        { value: 14, label: 'Bhubaneswar' },
        { value: 15, label: 'Cuttack' },
        { value: 16, label: 'Chandigarh' },
        { value: 17, label: 'Faridabad' },
        { value: 18, label: 'Ghaziabad' },
        { value: 19, label: 'Jamshedpur' },
        { value: 20, label: 'Jaipur' },
        { value: 21, label: 'Kochi' },
        { value: 22, label: 'Lucknow' },
        { value: 23, label: 'Nagpur' },
        { value: 24, label: 'Patna' },
        { value: 25, label: 'Raipur' },
        { value: 26, label: 'Visakhapatnam' },
        { value: 27, label: 'Agra' },
        { value: 28, label: 'Ajmer' },
        { value: 29, label: 'Kanpur' },
        { value: 30, label: 'Mysore' },
        { value: 31, label: 'Srinagar' },
        { value: 32, label: 'Pune' },
    ];

